@for (section of quoteCoversData(); track section.label; let i = $index; let isLast = $last) {
  @if (section.covers.length !== 0) {
    <h3 class="headline5-main-title">{{ section.label }}</h3>
    <div class="covers-list">
      @for (cover of section.covers; track cover.title) {
        <div class="cover-row">
          <p>{{ cover.title }}</p>
          @if (cover.price !== 0) {
            <p>{{ cover.price | currency }}</p>
          }
        </div>
      }
      @if (!isLast) {
        <pc-separator></pc-separator>
      }
    </div>
  }
}
